/**
 * Ein Fehler, der seinen HTTP-Status behält.
 *
 * Steht getrennt vom Client, weil auch die Beispieldaten ihn werfen: Eine
 * unbekannte Adresse muss dort dieselbe 404 ergeben wie am echten Server,
 * sonst prüft man die 404-Seite nie.
 */
export class ApiError extends Error {
  readonly status: number

  constructor(status: number, message: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }

  /** Nicht gefunden heißt: die Adresse ist falsch, nicht der Server kaputt. */
  get isNotFound(): boolean {
    return this.status === 404
  }
}
